/**
 * REV22 Fix 1 (docs/specs/REV22-hexa-stat-and-merged-masteries.md) — `common_core` is deliberately
 * absent from the `hexa_class_skill` catalog (it's the universal Sol Janus/Sol Hecate pair, not a
 * per-class skill — see `GoalsService`'s `HEXA_NODE_TYPES` doc comment), so `node.skillSlug` is
 * always null for it. This is the one shared place that maps its two fixed indices to their own
 * icon/tooltip slugs, so `HexaSkillTooltip` and `HexaSection`'s icon rendering never drift out of
 * sync on which index is which (previously only the tooltip layer had this split — see the spec's
 * Fix 1 bug writeup).
 */
export function commonCoreSlug(nodeIndex: number): 'sol-janus' | 'sol-hecate' | null {
  if (nodeIndex === 0) return 'sol-janus';
  if (nodeIndex === 1) return 'sol-hecate';
  return null;
}
